import { defineComponent as _defineComponent } from 'vue'
import { language, windowHelper } from '@tencent/ppd-base-libs';
import { CloseCircleIcon } from '@tencent/wphk-icon-vue';
import { FitHalfScreenDialogV2 } from '@tencent/wphk-ui';
import { computed, ref } from 'vue-demi';
import { getShareCodeCache, handleSetWxShareInfo } from '../../business';
import { i18n } from '../../i18n';
import { C2CConfig, C2CSharerAction } from '../../types';
import InviteList from './invite-list.vue';
import ShareReceive from './share-receive.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    c2cConfig: null
  },
  emits: ['onRestWxShare'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  c2cConfig: C2CConfig;
}


expose({ showDialog, hideDialog, onShare });


const isShowing = ref(false);

const mainDialog = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

const shareReceive = ref<InstanceType<typeof ShareReceive> | null>(null);

const skinInfo = computed(() => props.c2cConfig.skinInfo);

function goToTnc() {
  if (!props.c2cConfig.tncUrl) return;
  windowHelper.redirect(props.c2cConfig.tncUrl);
}

function onShare(sharerAction: C2CSharerAction) {
  shareReceive.value?.onShare(sharerAction);
}

function setWxShareInfo() {
  const wxShareUrl = getShareCodeCache(props.c2cConfig.actInfo.actId);
  if (!wxShareUrl) return;
  handleSetWxShareInfo({
    link: wxShareUrl,
    shareInfo: props.c2cConfig.shareInfo,
  });
}

function showDialog() {
  if (isShowing.value) return;
  isShowing.value = true;
  mainDialog.value?.showDialog();
  // 设置微信分享
  setWxShareInfo();
}

function hideDialog() {
  isShowing.value = false;
  mainDialog.value?.hideDialog();
  emits('onRestWxShare');
}

return { __sfc: true,props, emits, isShowing, mainDialog, shareReceive, skinInfo, goToTnc, onShare, setWxShareInfo, showDialog, hideDialog, language, CloseCircleIcon, FitHalfScreenDialogV2, i18n, InviteList, ShareReceive }
}

})